import firebase from 'firebase';
import moment from 'moment';
import React from 'react';

export const listTemporalObject = (tipo, list, consulta) => {

    if (consulta) {
        const starCountRef = firebase.database().ref().child(consulta);
        starCountRef.on('value', (snapshot) => {
            if (snapshot.val()) {
                let objects = snapshot.val();
                Object.keys(objects).map((key, index) => {
                    if (tipo === objects[key].tipo)
                        list.push(<option value={objects[key].concepto}>{objects[key].concepto}</option>)
                    return objects[key]
                })
            }
        });
    }
    return list;

};

export const randomMessage = (message, indexR) => {

    let mes = "Upps !! hemos tenido un problema";
    Object.keys(message).map((key, index) => {
        if (indexR === index)
            mes = message[key];
    });
    return mes;
};

export const varChatBot = (message, utils) => {

    message = message.replace("@nombre", utils.nombre);
    message = message.replace("@ultimaTarea", utils.ultimaTarea);
    message = message.replace("@tiempoUp", utils.tiempoUp);
    message = message.replace("@ultimoOkr", utils.ultimoOkr);
    message = message.replace("@hoy", moment().format("YYYYMMDD"));
    message = message.replace("@userId", utils.userId);
    message = message.replace("@empresa", utils.empresa);
    message = message.replace("@empresa", utils.equipo);

    return message;
}


export const attributesChat = (attributes) => {

    let att = [];
    if (attributes !== undefined && Object.keys(attributes).length > 0)
        Object.keys(attributes).map((item, i) => {
            att[item] = attributes[item];
        });

    return att;
}

export const listTemporalOpciones = (tipo, opciones, consulta) => {
    if (consulta) {
        const starCountRef = firebase.database().ref().child(consulta);
        starCountRef.on('value', (snapshot) => {
            if (snapshot.val()) {
                let objects = snapshot.val();
                Object.keys(objects).map((key, index) => {
                    if (tipo === objects[key].tipo) {
                        opciones[objects[key].concepto] = key;
                    }
                    return objects[key]
                })
            }
        });
    }
    return opciones;
};

export const rutaHupperSingle = (etapa) => {

    const posiblesRespuestas = 3; // posibles respuestas por cada etapa
    let wd = Math.round(Math.random() * (posiblesRespuestas - 1));
    return wd;
};


export const progressOKR = (objetivo, keyObjetivo, Tasks) => {

    let vImpacto = 0.25;
    let vTipologia = 0.1;
    let tiempoActividad = 60000 // tiempo en segundos
    let defaultV = 2;
    let nTareas = Math.round((objetivo.dificultad ? objetivo.dificultad : defaultV * ((objetivo.impacto * vImpacto) + 1)) * (vTipologia * objetivo.tipologia ? objetivo.tipologia : defaultV));
    let nTareasCompletas = 0;
    let nTiempoTrabajo = 0;


    Object.keys(Tasks).map((key2, index) => {

        if (moment(key2, "ww") >= moment().format('ww') - 2) {
            let Task = Tasks[key2];
            Object.keys(Task).map((key, index) => {
                if (keyObjetivo === Task[key].objetivo && Task[key].estado === 'finalizado') {
                    nTareasCompletas++;
                    nTiempoTrabajo = nTiempoTrabajo + Task[key].duracion;
                }
                return Task[key]
            });
        }
        return Tasks[key2];
    });

    let porTiempo = nTiempoTrabajo === 0 ? 7 : nTiempoTrabajo > nTareas * tiempoActividad ? 50 : Math.round((nTiempoTrabajo / (nTareas * tiempoActividad)) * 50);
    let porActividad = nTareasCompletas === 0 ? 8 : nTareasCompletas > nTareas ? 50 : Math.round((nTareasCompletas / nTareas) * 50);


    return porTiempo + porActividad;
}

export const responsefontHeaderObj = (win) => {
    let pem = -14.425 + 0.371 * win;
    return pem + 'em';
};


export const randonColor = (opacity, stilo) => {

    if (stilo === 1) {
        return 'rgba(' + (10 + Math.round(Math.random() * 30)) + ',' + (150 + Math.round(Math.random() * 30)) + ',' + (180 + Math.round(Math.random() * 30)) + ',' + opacity + ')'
    }

    else if (stilo === 2) {
        return 'rgba(' + (150 + Math.round(Math.random() * 30)) + ',' + (150 + Math.round(Math.random() * 30)) + ',' + (180 + Math.round(Math.random() * 30)) + ',' + opacity + ')'

    }
    else if (stilo === 3) {
        return 'rgba(' + (120 + Math.round(Math.random() * 30)) + ',' + (150 + Math.round(Math.random() * 30)) + ',' + (180 + Math.round(Math.random() * 30)) + ',' + opacity + ')'

    }

    return 'rgba(' + (80 + Math.round(Math.random() * 30)) + ',' + (150 + Math.round(Math.random() * 30)) + ',' + (180 + Math.round(Math.random() * 30)) + ',' + opacity + ')'

}

export const randomScalingFactor = () => {
    return Math.round(Math.random() * 100)
}

export const etapaHupper = (usuario, idUsuario, consulta) => {

    let etapa = 0;
    if (consulta) {
        const starCountRef = firebase.database().ref().child(consulta);
        starCountRef.on('value', (snapshot) => {
            if (snapshot.val()) {
                let objects = snapshot.val();

                Object.keys(objects).map((key, index) => {

                    let flagEtapa = true;
                    let talento = usuario.acumTalento ? usuario.acumTalento : 0;
                    let compromiso = usuario.acumCompromiso ? usuario.acumCompromiso : 0;
                    let impacto = usuario.acumImpacto ? usuario.acumImpacto : 0;

                    if (!(talento >= objects[key].talentoMin && talento <= objects[key].talentoMax))
                        flagEtapa = false;
                    if ((!impacto >= objects[key].impactoMin && impacto <= objects[key].impactoMax))
                        flagEtapa = false;
                    if (!(compromiso >= objects[key].compromisoMin && compromiso <= objects[key].compromisoMax))
                        flagEtapa = false;
                    if (flagEtapa) {
                        etapa = key;
                    }
                    return objects[key]
                })
            }
        });
    }
    let usProp = [];
    usProp["etapa"] = etapa === 0 && usuario.etapa ? usuario.etapa : etapa;
    firebase.database().ref(`Usuario/${idUsuario}`).update({
        ...usProp
    });
    return etapa;
};

export const dataBaseManager = (tipo, path, objectIn, mensaje, mensajeError) => {

    let men = null;
    let uid = null;
    let menajeok = mensaje && mensaje !== "default" ? mensaje : mensaje !== "default" ? "Hemos guardado tus datos correctamente" : null;
    let menajeer = mensajeError && mensajeError !== "default" ? mensajeError : mensajeError !== "default" ? "Uppss !!He tenido un probema al guardar estos datos." : null;
    switch (tipo) {
        case "insert":
            firebase.database().ref(path).set({
                ...objectIn
            }).then(
                () => {
                    if (menajeok)
                        men = menajeok;
                }).catch(err => {
                    if (menajeer)
                        men = menajeer;
                })

            break;
        case "update":


            firebase.database().ref(path).update({
                ...objectIn
            }).then(
                () => {
                    if (menajeok)
                        men = menajeok;
                }).catch(err => {
                    if (menajeer)
                        men = menajeer;
                })

            break;
        case "delete":
            return firebase.database().ref().child(path).remove();
        case "get":
            return firebase.database().ref().child(path);
        case "create":
            firebase.auth().createUserWithEmailAndPassword(objectIn.email, objectIn.ID);
            break;
        case "login":
            firebase.auth().signInWithEmailAndPassword(objectIn.email, objectIn.ID);
            break;
        case "logout":
            firebase.auth().signOut();
            break;
        case "key":
            return firebase.database().ref().child(path).push().key;
        default:
            break;


    }

    return { mensaje: men, uid };
}


